import { connect } from 'react-redux'

import { getUserName, getBiLabsUrl, getUserConfig, getUserId } from '@layers-frontend/commons/store/selectors/user'
import { canUseLayi } from '../../selectors/users'
import { patchConfig } from '../../actions/users'
import { openCsatModal, openLayiNotificationsModal } from '../../actions/modal'

import UserMenu from '../../components/UserComponents/UserMenu'

const mapStateToProps = state => ({
  userName: getUserName(state),
  userId: getUserId(state),
  biLabsUrl: getBiLabsUrl(state),
  config: getUserConfig(state),
  canUseLayi: canUseLayi(state)
})

const mapDispatchToProps = {
  patchConfig,
  openCsatModal,
  openLayiNotificationsModal
}

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu)
